import { ReactNode } from 'react';
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material';
import { palette } from './palette';
import { typography } from './typography';
import { breakpoints } from './breakpoints';
import { themeComponents } from './components';

type Props = {
  children: ReactNode;
};

export default function ThemeProvider({ children }: Props) {
  const theme = createTheme({
    palette,
    typography,
    breakpoints,
    components: themeComponents,
  });

  return <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>;
}
